import React from 'react';
import { Dialog } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface DialogFormProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void | Promise<void>;
    children: React.ReactNode;
    disableEnforceFocus?: boolean;
    paperSx?: SxProps<Theme>;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;   // <-- ajoute
}

export default function DialogForm({ open, onClose, onSubmit, children, disableEnforceFocus, paperSx, maxWidth }: DialogFormProps){
    return (
        <Dialog
            open={open}
            onClose={onClose}
            disableEnforceFocus={disableEnforceFocus}
            maxWidth={maxWidth}
            slotProps={{ paper:{ sx: paperSx } }}
        >
            <form onSubmit={onSubmit} style={{ display:'contents' }}>
                {children}
            </form>
        </Dialog>
    );
}
